export default "__VITE_ASSET__DFEQKyTz__"